import { useRef } from 'react';
import { ImagePlus, Link2, X, Loader2 } from 'lucide-react';
import { getImageUrl } from '../lib/api';

export const FrameRefPicker = ({ which, label, refPath, onUpload, onPick, onRemove, uploading }) => {
  const input = useRef(null);
  return (
    <div data-testid={`frameref-${which}`} className="mt-2 rounded-lg border border-dashed border-[#A78BFA]/30 bg-[#A78BFA]/[0.04] p-2.5">
      <input ref={input} type="file" accept="image/*" className="hidden" onChange={e => onUpload(e, which)} />
      {refPath ? (
        <div className="flex items-center gap-3">
          <img src={getImageUrl(refPath)} alt="reference" className="w-14 h-10 rounded object-cover border border-[#A78BFA]/40" />
          <div className="min-w-0 flex-1">
            <p className="text-[10px] font-semibold text-[#A78BFA] uppercase tracking-wider">Reference image set</p>
            <p className="text-[10px] text-[#8A8A93] truncate">The {label.toLowerCase()} will match its look, composition and lighting.</p>
          </div>
          <button data-testid={`upload-frameref-${which}`} onClick={() => input.current?.click()} className="text-[10px] text-[#8A8A93] hover:text-white">Replace</button>
          <button data-testid={`remove-frameref-${which}`} onClick={() => onRemove(which)} className="text-[#8A8A93] hover:text-red-400" title="Remove reference"><X className="w-3.5 h-3.5" /></button>
        </div>
      ) : (
        <div className="flex items-center gap-2 flex-wrap">
          <div className="min-w-0 flex-1">
            <p className="text-[10px] font-semibold text-[#A78BFA] uppercase tracking-wider">Reference image <span className="text-[#55555C] normal-case font-normal tracking-normal">(optional)</span></p>
            <p className="text-[10px] text-[#8A8A93]">Base the {label.toLowerCase()} on a photo or artwork — its framing, lighting and style are matched.</p>
          </div>
          <button data-testid={`upload-frameref-${which}`} onClick={() => input.current?.click()} disabled={uploading}
            className="text-[10px] px-2.5 py-1.5 rounded-md bg-[#A78BFA]/15 text-[#A78BFA] hover:bg-[#A78BFA]/25 border border-[#A78BFA]/30 flex items-center gap-1 disabled:opacity-50">
            {uploading ? <Loader2 className="w-3 h-3 animate-spin" /> : <ImagePlus className="w-3 h-3" />} Upload
          </button>
          <button data-testid={`pick-frameref-${which}`} onClick={() => onPick(which)}
            className="text-[10px] px-2.5 py-1.5 rounded-md bg-white/[0.04] text-[#C9C9D1] hover:text-white border border-white/10 flex items-center gap-1">
            <Link2 className="w-3 h-3" /> Pick existing
          </button>
        </div>
      )}
    </div>
  );
};
